import React from 'react';
import AsyncPageContent from 'common/components/page/AsyncPageContent';
import repositoryApi from '../api/repositoryApi';
import './repository.css';
import RepositoryContentList from './RepositoryContentList';
import { useNavigate } from 'react-router-dom';
import { RepositoryFileRead } from '../../../../store/generated/admin/repository-files';

export const RepositoryManagement = () => {
  const { data, error, isLoading } =
    repositoryApi.useApiAdminV1RepositoryRepositoryFilesListQuery(undefined);
  const navigate = useNavigate();
  const repositoryFiles = Array.isArray(data)
    ? data
    : Array.isArray((data as unknown as { results?: RepositoryFileRead[] })?.results)
      ? (data as unknown as { results?: RepositoryFileRead[] }).results
      : [];

  return (
    <AsyncPageContent isLoading={isLoading} error={error} data-testid="admin-repository-page">
      <RepositoryContentList
        data-testid="admin-repository-content"
        data={repositoryFiles}
        editable={true}
        onRowClick={repositoryFile => {
          navigate(`/settings/admin/repository-management/file-details`, {
            state: { data: repositoryFile },
          });
        }}
      />
    </AsyncPageContent>
  );
};
